import api from './api';
import { CVData } from '../types/cv';

class CVService {
    async getCV(id: string) {
        const response = await api.get(`/cv/${id}`);
        return response.data;
    }

    async createCV(data: CVData, template: string) {
        const response = await api.post('/cv/create', {
            ...data,
            template
        });
        return response.data;
    }

    async updateCV(id: string, data: CVData, template: string) {
        const response = await api.put(`/cv/${id}`, {
            ...data,
            template
        });
        return response.data;
    }

    async deleteCV(id: string) {
        const response = await api.delete(`/cv/${id}`);
        return response.data;
    }

    async duplicateCV(id: string) {
        const response = await api.post(`/cv/duplicate/${id}`);
        return response.data;
    }

    async getUserCVs(userId: string) {
        const response = await api.get(`/cv/user/${userId}`);
        return response.data;
    }

    /**
     * Rédaction assistée (résumé / expérience / formation).
     * @param {'summary' | 'experience' | 'education'} type
     */
    async generateDescription(
        type: 'summary' | 'experience' | 'education',
        context: Record<string, unknown> = {}
    ) {
        const response = await api.post('/cv/generate-description', { type, context });
        return response.data as { text: string; provider?: string };
    }
}

export default new CVService();
